import { Box, Button, Modal, Slide, useMediaQuery, } from "@mui/material";
import { WarningAmber } from "@mui/icons-material";

export const MessageModal = ({open, close, text, subtext, trigger}) => {
    const sm = useMediaQuery('(max-width:500px)')
    return (
        <Modal open={open}
            sx={{width: '100%', height:'100%'}}
            className="noutlined"
        >
            <Box height="100vh" width="100vw" position="fixed" top={0} left={0} display="flex" justifyContent="center" alignItems="center" px={2} sx={{ outline: 'none', backdropFilter: 'blur(8px)', bgcolor: 'rgba(255, 255, 255, 0.1)' }}>
                <Slide in={open} direction="up" className="noutlined" >
                    <Box width={sm ? '100%' : '456px'} bgcolor="#FFFFFF" px="24px" pb="24px" borderRadius="6px">
                        <Box minHeight="52px"></Box>
                        <Box display="flex" flexDirection="column" gap="20px" width="100%">
                            <WarningAmber/>
                            <Box color="#292C2F" fontSize={16} fontWeight={600} lineHeight="20px" >{text}</Box>
                            <Box color="#5B6167" fontSize={14} fontWeight={400} lineHeight="21px" >
                                {subtext}
                            </Box>
                            <Box display="flex" justifyContent="flex-end" width="100%" >
                                {trigger &&
                                    <Box fontSize={14} fontWeight={400} lineHeight="21px" width="25%" >
                                        <Button onClick={close} variant="contained" sx={{py:1, borderRadius:'8px'}} fullWidth>Got it</Button>
                                    </Box>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Slide>
            </Box>
        </Modal>
    )
}